// Varsel når en ansatt logger inn (velger seg selv i menylinjen): skiplukk som er lagt på den
// ansatte som oppfølger, og som den ikke har åpnet ennå (Order.oppfolgerSett). Vises hver gang
// til skiplukket er åpnet. NavBar viser den før UbehandledeOrdrer; onFerdig går videre dit.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDialog } from './tilgjengelighet';
import Ikon from '../ny-kundesamhandling/Ikon';
import { knappPrimar, knappSekundar } from '../ny-kundesamhandling/Skjema';
import { hentMineOrdrer } from '../utils/mineOrdrer';
import { erNyttForOppfolger } from '../skiplukk/felles';

export default function NyeSkiplukk({ ansatt, onFerdig }) {
  const [liste, setListe] = useState(null);

  useEffect(() => {
    let aktiv = true;
    hentMineOrdrer(ansatt).then((ordrer) => {
      if (!aktiv) return;
      const nye = (ordrer || []).filter((o) => erNyttForOppfolger(o, ansatt));
      setListe(nye);
      if (!nye.length) onFerdig();
    });
    return () => { aktiv = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ansatt]);

  const apen = Boolean(liste && liste.length);
  const dialogRef = useDialog(apen, onFerdig);
  if (!apen) return null;

  const fornavn = ansatt.split(' ')[0];
  const ett = liste.length === 1;

  return (
    <div className="no-print fixed inset-0 z-[60] flex items-start justify-center overflow-y-auto bg-black/40 p-3 sm:items-center">
      <div
        ref={dialogRef}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="ns-tittel"
        aria-describedby="ns-tekst"
        className="w-full max-w-lg space-y-3 rounded-2xl bg-white p-3 shadow-xl sm:p-5"
      >
        <div className="flex items-start gap-2">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-700 text-white">
            <Ikon navn="snofnugg" className="w-7 h-7" />
          </span>
          <div className="min-w-0">
            <h2 id="ns-tittel" className="text-lg font-bold text-slate-900 text-balance">
              {ett ? 'Du har fått et skiplukk å følge opp' : `Du har fått ${liste.length} skiplukk å følge opp`}
            </h2>
            <p id="ns-tekst" className="mt-1 text-slate-700">
              Hei {fornavn}! En kollega har bedt deg hjelpe {ett ? 'en kunde' : 'kunder'} med å finne riktige ski. Åpne
              {ett ? ' skiplukket' : ' skiplukkene'} for å se hva kunden trenger.
            </p>
          </div>
        </div>

        <ul className="max-h-[50vh] space-y-2 overflow-y-auto">
          {liste.map((o) => (
            <li key={o._id}>
              <Link
                to={`/order-details/${o._id}`}
                onClick={onFerdig}
                className="flex flex-wrap items-center gap-x-2 gap-y-1 rounded-xl border-2 border-teal-200 bg-teal-50 px-3 py-1.5 hover:bg-teal-100 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-600/50"
              >
                <span className="font-mono text-sm font-semibold text-slate-700">Nr. {o.ordreid}</span>
                <span className="min-w-0 flex-1 font-semibold text-slate-900 [overflow-wrap:anywhere]">
                  {o.Produkt ? `Skiplukk: ${o.Produkt}` : 'Skiplukk'}
                </span>
                {o.Ansatt && <span className="w-full text-sm text-slate-700">Ansvarlig: {o.Ansatt}</span>}
              </Link>
            </li>
          ))}
        </ul>

        <div className="flex flex-wrap justify-end gap-2">
          <button type="button" onClick={onFerdig} className={knappSekundar}>Senere</button>
          <Link to={`/order-details/${liste[0]._id}`} onClick={onFerdig} data-autofokus className={knappPrimar}>
            Åpne {ett ? 'skiplukket' : 'det første'} <Ikon navn="pil" className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </div>
  );
}
